import {post, get} from '@/utils/request'

export function logout (data) {
    return post('/logout', data)
}

export function getCaptchaCode () {
    return get('/captchaImage?t=' + new Date().getTime())
}

export function login (data) {
    return post('/login', data, 'json')
}

